import { useMemo, type ReactNode } from 'react'
import { ConfigProvider, theme } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { createAntTheme } from './tokens'
import { useThemeMode } from './store'
import './theme.css'

export default function ThemeProvider({ children }: { children: ReactNode }) {
  const mode = useThemeMode(state => state.mode)
  const config = useMemo(() => ({
    ...createAntTheme(mode),
    algorithm: mode === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm,
  }), [mode])

  return <ConfigProvider locale={zhCN} theme={config}>{children}</ConfigProvider>
}

// 静态确认框、消息和通知另建 React 根节点，也必须订阅同一主题。
ConfigProvider.config({
  holderRender: children => <ThemeProvider>{children}</ThemeProvider>,
})
